import { render, staticRenderFns } from "./channelIndex.vue?vue&type=template&id=18c2d53c&scoped=true&"
import script from "./channelIndex.vue?vue&type=script&lang=js&"
export * from "./channelIndex.vue?vue&type=script&lang=js&"
import style0 from "./channelIndex.vue?vue&type=style&index=0&id=18c2d53c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2d53c",
  null
  
)

export default component.exports